<template>
  <AssetNotificationRules />
</template>

<script lang="ts">
import { defineComponent, watch } from 'vue'
import { useI18n } from 'vue-i18n'
import AssetNotificationRules from "@/components/content/AssetNotificationRules.vue";

export default defineComponent({
  name: 'AssetNotificationRulesView',
  components: { AssetNotificationRules },

  setup(props, context) {
    const i18n = useI18n()

    context.emit('pageName', i18n.t('aside.menu.pages.assetNotificationRules'))

    watch(() => i18n.locale.value, () => {
      context.emit('pageName', i18n.t('aside.menu.pages.assetNotificationRules'))
    })
  }
})
</script>
